// extracted by mini-css-extract-plugin
export default {"trustedRetailerBanner":"v0-z","trustedRetailerTooltipWrapper":"w0-z"};